import { render } from "./MFITTRefundPrices.vue?vue&type=template&id=66718c7c&scoped=true"
import script from "./MFITTRefundPrices.vue?vue&type=script&lang=js"
export * from "./MFITTRefundPrices.vue?vue&type=script&lang=js"

import "./MFITTRefundPrices.vue?vue&type=style&index=0&id=66718c7c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-66718c7c"

export default script